import React from "react";
import ReactExport from "react-data-export";
import moment from "moment";
import {getArrayObjByValue} from "../../utils";
import {STATIC_VARIABLE} from "../../constants/static-data";


const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;

const titleStyle = {
  fill: {
    patternType: "solid",
    fgColor: {rgb: "C0C0C0"}
  },
  alignment: {
    vertical: 'center',
    horizontal: 'center',
  },
  border: {
    top: { style: 'thin', color: '000000' },
    bottom: { style: 'thin', color: '000000' },
    left: { style: 'thin', color: '000000' },
    right: { style: 'thin', color: '000000' }
  }
};

const columnStyle = {
  border: {
    top: { style: 'thin', color: '000000' },
    bottom: { style: 'thin', color: '000000' },
    left: { style: 'thin', color: '000000' },
    right: { style: 'thin', color: '000000' }
  }
}

function ExcelShopOrderList(props) {
  const {items} = props;

  const dataItem = items.map((e, i) => ([
    {value: i+1, style: columnStyle},
    {value: e.orderID, style: columnStyle},
    {value: `#${e.userID}-${e.username}`, style: columnStyle},
    {value: `#${e.shopID}-${e.shopName}`, style: columnStyle},
    {value: getArrayObjByValue(STATIC_VARIABLE.orderStatusArray, e.orderStatus).label, style: columnStyle},
    {value: `RM ${e.totalAmount}`, style: columnStyle},
    {value: e.createdAt, style: columnStyle},
    {value: e.memberCreatedAt, style: columnStyle},
  ]))

  const multiDataSet = [
    {
      columns: [
        {title: "No", style: titleStyle, width: {wpx: 30}},
        {title: "Order ID", style: titleStyle, width: {wpx: 150}},
        {title: "User", style: titleStyle, width: {wpx: 270}},
        {title: "Service By", style: titleStyle, width: {wpx: 270}},
        {title: "Order Status", style: titleStyle, width: {wpx: 150}},
        {title: "Total", style: titleStyle, width: {wpx: 150}},
        {title: "Created Date", style: titleStyle, width: {wpx: 150}},
        {title: "Member Join Date", style: titleStyle, width: {wpx: 150}},
      ],
      data: dataItem
    }
  ];

  return (
    <ExcelFile
      element={<button id='shop-order-export' style={{ display: 'none' }}>Download Data</button>}
      filename={`Shop-Order-List-${moment().unix()}`}
    >
      <ExcelSheet dataSet={multiDataSet} name="Organization"/>
    </ExcelFile>
  )
}

export default ExcelShopOrderList;
